import { styled, Skeleton, SxProps } from '@mui/material'
import { UserAvatar } from '$common/avatar'
import { AvatarSize } from '$common/avatar/avatar-base/types'
import { AVATAR_SIZES } from '$common/avatar/avatar-base/conf'

interface Props {
  userIds: string[]
  size?: AvatarSize
  className?: string
  sx?: SxProps
  onClick?: () => unknown
}

export const AvatarGroup = ({
  userIds,
  size = AvatarSize._3XS,
  className,
  sx,
  onClick,
}: Props) => {
  const total = userIds?.length > 3 ? 3 : userIds?.length
  return (
    <Root
      className={className}
      sx={{ ...sx, cursor: onClick ? 'pointer' : undefined }}
      onClick={onClick}
    >
      {userIds ? (
        <AvatarWrapper>
          {userIds
            .slice(0, total)
            .reverse()
            .map(id => {
              return <StyledUserAvatar key={id} userId={id} size={size} />
            })}
        </AvatarWrapper>
      ) : (
        <div style={{ display: 'flex' }}>
          <FormattedSkeleton
            animation={false}
            width={size ? `${AVATAR_SIZES[size]}px` : '24px'}
            height={size ? `${AVATAR_SIZES[size]}px` : '24px'}
            variant="circular"
          />
          <FormattedSkeleton
            animation={false}
            variant="circular"
            width={size ? `${AVATAR_SIZES[size]}px` : '24px'}
            height={size ? `${AVATAR_SIZES[size]}px` : '24px'}
          />
          <FormattedSkeleton
            animation={false}
            variant="circular"
            width={size ? `${AVATAR_SIZES[size]}px` : '24px'}
            height={size ? `${AVATAR_SIZES[size]}px` : '24px'}
          />
        </div>
      )}
    </Root>
  )
}

const FormattedSkeleton = styled(Skeleton)`
  border: 1px solid #ffffff;
  margin: 0 -5px;
  box-sizing: border-box;
  &:not(:first-child) {
    margin-inline-end: -7px;
  }
`

const AvatarWrapper = styled('div')`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  .MuiBadge-root:not(:first-child) .avatar-base__root {
    margin-inline-end: -7px;
  }
`

const Root = styled('button')`
  height: 22px;
  width: fit-content;
  background: transparent;
  border: none;
  outline: none;
  padding: unset;
`

const StyledUserAvatar = styled(UserAvatar)`
  outline: 1px solid ${({ theme }) => theme.palette.neutral000};
`
